import {
  PERMISSION_ACTION_APPROVE,
  PERMISSION_ACTION_DELETE,
  PERMISSION_ACTION_DENY,
  PERMISSION_ACTION_EDIT,
  PERMISSION_ACTION_PUBLISH,
  PERMISSION_ACTION_VIEW,
  PERMISSION_ENTITY_PURCHASE_ORDER,
  type PermissionAction
} from '@klear/constants'
import {
  ORDER_EVENT_STATUS_APPROVED,
  ORDER_EVENT_STATUS_DENIED,
  ORDER_EVENT_STATUS_DRAFT,
  ORDER_EVENT_STATUS_PUBLISHED
} from '@klear/constants/order-event-status'
import type { OrderEventStatusLabelsFor } from '@klear/order-event-lifecycle/lifecycle'

export const PURCHASE_ORDER_STATUS_LABELS = {
  [ORDER_EVENT_STATUS_DRAFT]: 'Draft',
  [ORDER_EVENT_STATUS_PUBLISHED]: 'Published',
  [ORDER_EVENT_STATUS_APPROVED]: 'Approved',
  [ORDER_EVENT_STATUS_DENIED]: 'Denied'
} as const satisfies OrderEventStatusLabelsFor<typeof PERMISSION_ENTITY_PURCHASE_ORDER>

export const PURCHASE_ORDER_ACTION_LABELS = {
  [PERMISSION_ACTION_VIEW]: 'View',
  [PERMISSION_ACTION_EDIT]: 'Edit',
  [PERMISSION_ACTION_DELETE]: 'Delete',
  [PERMISSION_ACTION_PUBLISH]: 'Publish',
  [PERMISSION_ACTION_APPROVE]: 'Approve',
  [PERMISSION_ACTION_DENY]: 'Deny'
} as const satisfies Partial<Record<PermissionAction, string>>
